"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationWidget = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _classnames = _interopRequireDefault(require("classnames"));

var _timeAgo = require("../../../utils/time-ago");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TYPES = {
  CONTENT: 'content',
  NEW: 'new',
  IMAGE: 'image'
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _theme$palette$other;

  return {
    paperCustomization: {
      overflow: 'auto'
    },
    widgetIcon: {
      color: '#FFF',
      position: 'relative'
    },
    avatar: {
      backgroundColor: theme.palette.primary.light
    },
    notificationList: _defineProperty({
      minWidth: 360,
      maxWidth: 360,
      maxHeight: 480
    }, theme.breakpoints.down('392'), {
      maxHeight: 344,
      minWidth: 'unset'
    }),
    listItem: {
      justifyContent: 'space-between',
      position: 'relative',
      minHeight: '56px',
      '&:hover': {
        backgroundColor: '#f0f0f0'
      },
      '&:nth-of-type(n+2)': {
        marginTop: 4
      },
      '&.unreadNotification': {
        backgroundColor: theme.palette.background.hover
      }
    },
    itemTime: {
      position: 'absolute',
      top: 8,
      right: 16
    },
    textPositioning: {
      whiteSpace: 'normal'
    },
    contentText: {
      fontSize: 10,
      lineHeight: '14px',
      marginTop: '6px'
    },
    contentArea: {
      display: 'flex',
      alignItems: 'center'
    },
    notificationTitle: {
      display: 'flex',
      flexDirection: 'column'
    },
    timeContainer: {
      marginLeft: 12,
      width: 32,
      textAlign: 'end',
      alignSelf: 'flex-start',
      fontSize: 10,
      color: theme.palette.text.secondary
    },
    unreadDot: {
      position: 'absolute',
      left: 7,
      top: 23,
      border: '3px solid #ffb400',
      borderRadius: '50%'
    },
    notificationCount: {
      backgroundColor: ((_theme$palette$other = theme.palette.other) === null || _theme$palette$other === void 0 ? void 0 : _theme$palette$other.activeRating) || '#FFB400',
      borderRadius: '50%',
      color: theme.palette.text.primary,
      fontSize: 10,
      height: 16,
      lineHeight: '15px',
      position: 'absolute',
      right: 14,
      top: 15,
      width: 16
    }
  };
});

var NotificationWidget = function NotificationWidget(props) {
  var items = props.items,
      onWidgetClick = props.onWidgetClick,
      onClickItem = props.onClickItem,
      className = props.className,
      showUnreadCount = props.showUnreadCount,
      hide = props.hide,
      hidden = props.hidden,
      showBackdrop = props.showBackdrop,
      backdropClass = props.backdropClass;
  var classes = useStyles();
  var widgetRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)({
    isOpen: false,
    ref: null,
    items: items,
    unreadCount: items.filter(function (e) {
      return e.isUnread;
    }).length,
    openBackdrop: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleClose = function handleClose() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isOpen: false,
        ref: null,
        openBackdrop: false
      });
    });
  };

  var handleCloseBackdrop = function handleCloseBackdrop() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        openBackdrop: false
      });
    });
  };

  var filterUnreadItemsIds = function filterUnreadItemsIds() {
    return state.items.filter(function (e) {
      return e.isUnread;
    }).map(function (e) {
      return e.id;
    });
  };

  var showNotification = function showNotification() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isOpen: true,
        ref: widgetRef.current,
        openBackdrop: true
      });
    });
  };

  var internalWidgetClick = function internalWidgetClick() {
    if (!state.isOpen) {
      if (state.items.length) {
        showNotification();
        onWidgetClick(filterUnreadItemsIds());
      }

      return;
    }

    handleClose();
  };

  var formatTimeInfo = function formatTimeInfo(value) {
    if (value instanceof Date) {
      return (0, _timeAgo.format)(value, 'pt_BR');
    }

    return value;
  };

  var markNotificationAsRead = function markNotificationAsRead(notificationId) {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        items: prev.items.map(function (e) {
          return e.id === notificationId ? _objectSpread(_objectSpread({}, e), {}, {
            isUnread: false
          }) : e;
        })
      });
    });
  };

  var onItemInnerClick = function onItemInnerClick(itemId, itemCallback) {
    markNotificationAsRead(itemId);
    onClickItem(itemId);

    if (typeof itemCallback === 'function') {
      itemCallback();
    }
  };

  var isShowingNotification = function isShowingNotification() {
    return showUnreadCount && state.unreadCount > 0;
  };

  var unreadCountFormater = function unreadCountFormater() {
    if (state.unreadCount > 9) return '9+';
    return state.unreadCount;
  };

  (0, _react.useEffect)(function () {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        items: items,
        unreadCount: items.filter(function (e) {
          return e.isUnread;
        }).length
      });
    });
  }, [items]);
  if (hide) return null;
  return /*#__PURE__*/_react.default.createElement(_core.Hidden, hidden, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: internalWidgetClick,
    ref: widgetRef,
    style: {
      position: 'relative'
    },
    className: (0, _classnames.default)([classes.widgetIcon, className]),
    "aria-label": "Notifica\xE7\xF5es"
  }, /*#__PURE__*/_react.default.createElement(_icons.NotificationsNoneRounded, {
    "aria-label": "Notifica\xE7\xE3o",
    style: {
      fontSize: '1.5em'
    }
  }), isShowingNotification() && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.notificationCount
  }, unreadCountFormater())), /*#__PURE__*/_react.default.createElement(_core.Popover, {
    id: "notificationsList",
    open: state.isOpen,
    anchorEl: state.ref,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    elevation: 5,
    className: classes.paperCustomization
  }, /*#__PURE__*/_react.default.createElement(_core.List, {
    className: classes.notificationList
  }, state.items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: item.id,
      className: (0, _classnames.default)([classes.listItem, item.isUnread && 'unreadNotification']),
      onClick: function onClick() {
        return onItemInnerClick(item.id, item.onClick);
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.contentArea
    }, /*#__PURE__*/_react.default.createElement(_core.ListItemAvatar, {
      style: {
        alignSelf: 'flex-start'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      className: classes.avatar
    }, /*#__PURE__*/_react.default.createElement(NotificationIcon, {
      type: item.type,
      imgSrc: item.imgSrc
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.notificationTitle
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.textPositioning,
      color: "textPrimary",
      variant: "body2"
    }, item.title), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: (0, _classnames.default)([classes.textPositioning, classes.contentText]),
      color: "textSecondary",
      variant: "caption"
    }, item.content))), item.time && /*#__PURE__*/_react.default.createElement("span", {
      className: classes.timeContainer
    }, formatTimeInfo(item.time)), item.isUnread && /*#__PURE__*/_react.default.createElement("span", {
      className: classes.unreadDot
    }));
  })))), showBackdrop && /*#__PURE__*/_react.default.createElement(_core.Backdrop, {
    open: state.openBackdrop,
    onClick: handleCloseBackdrop,
    className: backdropClass ? backdropClass.root : ''
  }));
}; // eslint-disable-next-line react/prop-types


exports.NotificationWidget = NotificationWidget;

var NotificationIcon = function NotificationIcon(_ref) {
  var type = _ref.type,
      imgSrc = _ref.imgSrc;

  if (type === TYPES.NEW) {
    return /*#__PURE__*/_react.default.createElement(_icons.NewReleases, null);
  }

  if (type === TYPES.CONTENT) {
    return /*#__PURE__*/_react.default.createElement(_icons.LibraryAdd, null);
  }

  if (type === TYPES.IMAGE) {
    return /*#__PURE__*/_react.default.createElement("img", {
      src: imgSrc,
      alt: "Notifica\xE7\xE3o",
      width: "40",
      height: "40"
    });
  }

  return null;
};

NotificationWidget.propTypes = {
  /**
   * Lista de Notificacões
   */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** identificador da notificacao usada como parametro no onClick do item */
    id: _propTypes.default.number.isRequired,

    /**
     * Tipo de notificação, tem impacto no icone exibido:
     *
     * * `content` para Novo Conteúdo
     * * `new` para nova Funcionalidade
     * * `image` para utilizar uma imagem fornecida
     */
    type: _propTypes.default.oneOf([TYPES.CONTENT, TYPES.NEW, TYPES.IMAGE]),

    /** Função que sera executada quando a notificação for clicada */
    onClick: _propTypes.default.func,

    /** Título da notificação */
    title: _propTypes.default.string,

    /** Conteúdo da notificação */
    content: _propTypes.default.string,

    /** Data da notificação */
    time: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]),

    /** Usado para indicar se a notificação está marcada como não lida */
    isUnread: _propTypes.default.bool,

    /** fonte da imagem que será exibido quando for do tipo img */
    imgSrc: _propTypes.default.string
  })).isRequired,

  /** callback que sera chamada ao clicar no icone do widget de notificacão */
  onWidgetClick: _propTypes.default.func,

  /** callback que sera chamada ao clicar no item de notificação */
  onClickItem: _propTypes.default.func,

  /** classes de css para customizar o componente */
  className: _propTypes.default.string,

  /** quantidade de notificação indicadas como não lidas, valor default `true` */
  showUnreadCount: _propTypes.default.bool,

  /** Flag de curto-circuito para esconder o widget */
  hide: _propTypes.default.bool,

  /**
   * Propriedades para controlar quando esconder um objeto usa a mesma api do Componente do MUI Hidden
   * {@link https://v4.mui.com/components/hidden/#hidden [Detalhes]}
   */
  hidden: _propTypes.default.shape({
    lgDown: _propTypes.default.bool,
    lgUp: _propTypes.default.bool,
    mdDown: _propTypes.default.bool,
    mdUp: _propTypes.default.bool,
    only: _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
    smDown: _propTypes.default.bool,
    smUp: _propTypes.default.bool,
    xlDown: _propTypes.default.bool,
    xlUp: _propTypes.default.bool,
    xsDown: _propTypes.default.bool,
    xsUp: _propTypes.default.bool
  }),

  /** Define se será exibido um backdrop ao abrir as notificações */
  showBackdrop: _propTypes.default.bool,

  /** Objeto com classe "root" para estilização do backdrop */
  backdropClass: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  })
};
NotificationWidget.defaultProps = {
  onWidgetClick: function onWidgetClick() {
    return null;
  },
  onClickItem: function onClickItem() {
    return null;
  },
  className: '',
  showUnreadCount: true,
  hide: false,
  hidden: {
    lgDown: false,
    lgUp: false,
    mdDown: false,
    mdUp: false,
    only: null,
    smDown: false,
    smUp: false,
    xlDown: false,
    xlUp: false,
    xsDown: false,
    xsUp: false
  },
  showBackdrop: false,
  backdropClass: null
};